import { Inline, Stack } from '@atlaskit/primitives/compiled';
import React from 'react';

import { LoadingSkeleton } from '@townsquare/loading-skeleton';
import { YourAppsPageLoadingSkeleton } from '@townsquare/your-apps/full-page-skeleton';

export const AppsViewRedesignLoadingSkeleton = () => {
	return (
		<Stack space="space.250">
			<Inline space="space.200" spread="space-between" alignBlock="center" shouldWrap>
				<LoadingSkeleton height="20px" width="80px" />

				<Inline space="space.100" alignBlock="center">
					<LoadingSkeleton height="32px" width="95px" />
					<LoadingSkeleton height="32px" width="200px" />
				</Inline>
			</Inline>
			<YourAppsPageLoadingSkeleton />
		</Stack>
	);
};
